import React from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { TbCertificate, TbCertificateOff } from 'react-icons/tb'
import defaultTexts from '../../../texts/texts'
import { capitalizeFirstLetter } from '../../_common/_helpers/string'

const CertificateView = (props) => {
  const { domains, is_valid, type, expiration_date, expired } = props
  const theme = useTheme()

  const wrapperStyle = {
    borderBottom: '1px dotted',
    borderColor: theme.palette.lightSilver,
    padding: '10px 0px',
    margin: '0px 20px 10px 0px',
  }

  const valueLgStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '20px',
    fontWeight: '500',
    marginBottom: '10px',
  }

  const keySmStyle = {
    color: theme.palette.grayX11,
    fontSize: '16px',
    fontWeight: '500',
  }

  const valueSmStyle = {
    color: theme.palette.greenSheen,
    fontSize: '16px',
    fontWeight: '500',
  }

  return (
    <Box sx={wrapperStyle}>

      <Box sx={valueLgStyle}>
        {
          domains.map((item, index) => (
            <Box key={index} sx={{ paddingBottom: '5px' }}>{item}</Box>
          ))
        }
      </Box>

      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{
          marginBottom: '5px',
        }}
      >
        <Box sx={keySmStyle}>{defaultTexts.sslCertificate}</Box>
        <Box>
          {
            is_valid ?
            <TbCertificate size={32} color={theme.palette.mayGreen} /> :
            <TbCertificateOff size={32} color={theme.palette.deepLemon} />
          }
        </Box>
      </Stack>

      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{
          marginBottom: '5px',
        }}
      >
        <Box sx={keySmStyle}>{defaultTexts.type}</Box>
        <Box sx={valueSmStyle}>{capitalizeFirstLetter(type)}</Box>
      </Stack>

      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{
          marginBottom: '5px',
        }}
      >
        <Box sx={keySmStyle}>{defaultTexts.expirationDate}</Box>
        <Box
          sx={{
            ...valueSmStyle,
            color: expired ? theme.palette.coralRed : theme.palette.greenSheen,
          }}
        >
          { expiration_date ? expiration_date : defaultTexts.autoRenew}
        </Box>
      </Stack>

    </Box>
  )
}

export default CertificateView